import React from 'react'
import { UploadSupplierFormAdminStyle } from './styled'
import {
  Button,
  Image,
  InputUpload,
  Section,
  InputTextarea,
} from '../../components'
import { ICONS } from '../../themes'

import { ROUTE_PATH, redirect, STRING } from '../../helpers'

export class UploadSupplierFormAdminContainer extends React.Component {
  render() {
    return (
      <UploadSupplierFormAdminStyle>
        {/* PAGE TITLE
        -----------------------------------------------------
        -----------------------------------------------------
        */}
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                id="page_icon_supplier_management"
                src={ICONS['icon-user-white.svg']}
                alt="page icon"
              />
            </Section>

            <Section className="title-and-breadcrumb">
              <Section id="page_title_supplier_management" className="title">
                {STRING.SUPPLIER_MANAGEMENT}
              </Section>

              <Section
                id="page_breadcrumb_supplier_management"
                className="breadcrumbs"
              >
                <Button
                  onClick={() => {
                    this.props.history.push(ROUTE_PATH.HOME.LINK)
                  }}
                  className="breadcrumb"
                >
                  <span>{STRING.HOME}</span>
                </Button>

                <Button
                  onClick={() => {
                    redirect(ROUTE_PATH.SUPPLIER_MANAGEMENT_ADMIN.LINK)
                  }}
                  className="breadcrumb"
                >
                  <span>{STRING.SUPPLIER_MANAGEMENT}</span>
                </Button>

                <Button className="breadcrumb current">
                  <span>Upload Supplier</span>
                </Button>
              </Section>
            </Section>
          </Section>
        </Section>

        {/* PAGE CONTENT
        -----------------------------------------------------
        -----------------------------------------------------
        */}
        <Section className="main-content form">
          <Section className="content-body">
            <Section className="form-wrapper">
              <Section className="form-group-title">Upload Supplier</Section>

              <Section className="form-group is-error">
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <InputUpload id="upload" />
                    <Button className="theme-blue">Upload</Button>
                  </Section>

                  <Section className="message">error</Section>
                </Section>
              </Section>

              <a className="file-download-link" href="#">
                Download Supplier Template
              </a>

              <Section className="form-group">
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <div className="upload-log-outter-wrapper">
                      <div className="upload-log-wrapper">
                        <span className="error">
                          Row 12 of TaxID is in the wrong format
                        </span>
                        <br />
                        <span className="success">
                          Row 12 of TaxID is in the wrong format
                        </span>
                        <br />
                        Row 25 of Email must not be null
                        <br />
                        Row 12 of TaxID is in the wrong format <br />
                        Row 25 of Email must not be null
                        <br />
                        Row 12 of TaxID is in the wrong format <br />
                        Row 25 of Email must not be null
                        <br />
                        Row 12 of TaxID is in the wrong format <br />
                        Row 25 of Email must not be null
                        <br />
                        Row 12 of TaxID is in the wrong format <br />
                        Row 25 of Email must not be null
                        <br />
                      </div>
                    </div>
                  </Section>
                </Section>
              </Section>
            </Section>

            <Section className="form-actions">
              <Button className="theme-border-gray">Cancel</Button>
            </Section>
          </Section>
        </Section>
      </UploadSupplierFormAdminStyle>
    )
  }
}
